/**
 * This is the entry point for specific javascript of theme
 */
import './player-customization.js';
import './complementary-products.js';

console.log('hellasverona Theme')

// document.addEventListener('DOMContentLoaded', () => {
//   const backToTop = document.getElementById('back-to-top');
//   if (!backToTop) return;
//   window.addEventListener('scroll', () => {
//     backToTop.style.display = window.scrollY > 300 ? 'block' : 'none';
//     backToTop.classList.add('visible');

//   });
//   backToTop.addEventListener('click', () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   });
// });

// //crea una funzione che cerca se nel menu esiste un a con come testo (controllando tutto lowercase) "Halloween". Se si al suo li aggiungi la classe "special-halloween". Fai lo stesso controllando anche nel menu mobile
// document.addEventListener('DOMContentLoaded', () => {
//   const menuItems = document.querySelectorAll('.header__primary-nav .header__primary-nav-item .h6');
//   menuItems.forEach(item => {
//     if (item.textContent.toLowerCase().includes('halloween')) {
//       item.parentElement.classList.add('special-halloween');
//     }
//   });

//   const menuWithSubItems = document.querySelectorAll('.header__primary-nav .header__primary-nav-item .header__menu-disclosure summary.h6');
//   menuWithSubItems.forEach(item => {
//     if (item.textContent.toLowerCase().includes('halloween')) {
//       item.parentElement.parentElement.parentElement.classList.add('special-halloween');
//     }
//   });


//   const mobileMenuItems = document.querySelectorAll('.header-sidebar .header-sidebar__linklist li .header-sidebar__linklist-button');
//   mobileMenuItems.forEach(item => {
//     if (item.textContent.toLowerCase().includes('halloween')) {
//       item.parentElement.classList.add('special-halloween');
//     }
//   });
// });